import { AppErrors } from "../../../services/config"

export default function getErrorMessage(e: unknown): string {
    if (e instanceof Error) {
        return e.message
    }
    return AppErrors.UNKNOWN_ERROR
}
